import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { QUERY_KEYS } from 'settings/config';

/** Get the Enquiry Lists*/
interface useEnquiryListProps {
  orgId?: string;
  listingId?: string;
  pageSize?: number;
}
export const useEnquiryList = ({
  orgId: overrideOrgId,
  listingId,
  pageSize,
}: useEnquiryListProps) => {
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);
  const orgId = overrideOrgId || activeBuyerOrgId;
  return useQuery(
    [QUERY_KEYS.enquiryList, listingId],
    ({ pageParam }) =>
      new ApiClient().EnquiryApi.orgMarketplaceListingEnquiryList({
        listingId: listingId || '',
        buyerOrgId: orgId as string,
        page: pageParam || 1,
        pageSize: pageSize || 10,
      }),
    {
      select: (data) => data.data,
      enabled: !!listingId && !!orgId,
    }
  );
};
